var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRahulLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 82,
    viewBox: "0 0 342 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.5913 82L98.7896 0L133.988 82H117.366L98.7896 40.0238L80.2127 82H63.5913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.687 50.7619V82H137.043V3.90476H152.687V35.1429H183.974V3.90476H199.618V82H183.974V50.7619H152.687Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.145 50.7619V3.90476H227.789V50.7619C227.789 55.0734 229.317 58.7545 232.372 61.8051C235.427 64.8557 239.114 66.381 243.433 66.381C247.751 66.381 251.438 64.8557 254.493 61.8051C257.549 58.7545 259.076 55.0734 259.076 50.7619V3.90476H274.72V50.7619C274.72 54.9107 273.926 58.8968 272.337 62.7202C270.748 66.5436 268.487 69.9196 265.554 72.8482C262.621 75.7768 259.239 78.0342 255.41 79.6205C251.58 81.2068 247.588 82 243.433 82C239.277 82 235.285 81.2068 231.455 79.6205C227.626 78.0342 224.245 75.7768 221.311 72.8482C218.378 69.9196 216.117 66.5436 214.528 62.7202C212.94 58.8968 212.145 54.9107 212.145 50.7619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.247 3.90476H302.891V66.381H342V82H287.247V3.90476Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8661 0H0V17.1051H37.7679C29.4643 32.6433 18.4821 38.9108 0.535714 40.3471V57.8439C33.3482 56.6688 58.3929 33.6879 59.8661 0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 55.6242C38.4891 52.437 41.5757 50.0099 46.3393 44.9172C56.6164 58.024 59.1004 66.2845 60 82H42.0536C41.3078 70.1669 38.9136 64.4704 31.875 55.6242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRahulLogo);
export default __webpack_public_path__ + "static/media/rahul-logo.4240669d9d682b8be98dc5f94333d4b8.svg";
export { ForwardRef as ReactComponent };